import React from 'react';
import { View, Dimensions, Text, Image, ScrollView, ActivityIndicator, TouchableHighlight } from 'react-native';
import { CheckBox, Button, Icon } from 'react-native-elements';
import { isConnectedToNetwork, getReadOnlyData } from '../BlockLib';
import Lib from '../Lib';

const { showToast, getStorageValue, setStorageValue } = Lib;
const { IMG_DATA, USDT, TOKEN, TOKEN_NAME } = require('../Data');

class PanelMenu extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: 'busy'
    };
  }

  async componentDidMount() {
    this.setState({ show: 'game' });
    const data = await getReadOnlyData();
    this.setState({ data });

    this.interval = setInterval(async () => {
      const data = await getReadOnlyData();
      this.setState({ data });
    }, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  async handleShow(show) {
    const isConnected = await isConnectedToNetwork();
    if (!isConnected) {
      return showToast('NOT CONNECTED TO NETWORK');
    }
    this.props.handleShow(show)
  }

  render() {
    let price = this.state.data ? this.state.data.price : '';
    let pctg = this.state.data ? this.state.data.pctgDaily : '';
    const ss = { flex: 1, justifyContent: 'center', paddingVertical: 10 };
    let msg = 'Revenue from RTK Warriors + interest from FLUX ensure Dragon Token to have increasing buyback price.';
    const msg2 = <Text style={{}}></Text>
    return (
      <View>
        <View style={{ alignItems: 'center', justifyContent: 'center', paddingVertical: 10, paddingHorizontal: 20 }}>
          <Text> </Text>
          <TouchableHighlight onPress={() => Lib.openUrl('https://confluxscan.io/token/cfx:ach9vx5dvzv7vtdnjvgssjk88m9du9brjawty666b1')}>
            <View>
              <Text style={{ textAlign: 'center' }}>DRAGON TOKEN</Text>
              <Text style={{ textAlign: 'center', fontSize: 10 }}>cfx:ach9vx5dvzv7vtdnjvgssjk88m9du9brjawty666b1</Text>
            </View>
          </TouchableHighlight>
          <Text> </Text>
          <TouchableHighlight onPress={() => Lib.openUrl('https://bscscan.com/token/0x888c16c4Bb5Db9974Fb7B5EBe8CeB1625Dc1d7eb')}>
            <View>
              <Text style={{ textAlign: 'center' }}>DRAGON TOKEN AT BSC</Text>
              <Text style={{ textAlign: 'center', fontSize: 10 }}>0x888c16c4Bb5Db9974Fb7B5EBe8CeB1625Dc1d7eb</Text>
            </View>
          </TouchableHighlight>
          <Text> </Text>
          <Text style={{ textAlign: 'center' }}>{msg.toUpperCase()}</Text>
          <Text> </Text>
        </View>
        <View style={{ padding: 5, backgroundColor: '#eee' }}>
          <Text> </Text>
          <Text style={{ textAlign: 'center' }}>CURRENT BUYBACK PRICE</Text>
          <Text style={{ textAlign: 'center' }}><Text style={{ fontWeight: 'bold' }}>{price}</Text> {USDT}</Text>
          <Text style={{ textAlign: 'center' }}>AVERAGE DAILY PRICE INCREASE <Text style={{ fontWeight: 'bold' }}>{pctg}</Text> %</Text>
          <Text> </Text>
          <View style={{ flexDirection: 'row', alignItems: 'stretch' }}>
            <View style={{ flex: 1, padding: 5 }}>
              <Icon name='collections' size={40} />
              <View style={ss}><Text style={{ textAlign: 'center' }}>OWNED WARRIORS</Text></View>
              <Button title="MANAGE" onPress={() => this.handleShow('MANAGE')} />
            </View>
            <View style={{ flex: 1, padding: 5 }}>
              <Icon name='account-circle' size={40} />
              <View style={ss}><Text style={{ textAlign: 'center' }}>NEW WARRIOR</Text></View>
              <Button title="MINT" onPress={() => this.handleShow('MINT')} />
            </View>
            <View style={{ flex: 1, padding: 5 }}>
              <Icon name='account-balance-wallet' size={40} />
              <View style={ss}><Text style={{ textAlign: 'center' }}>{TOKEN_NAME.toUpperCase()}</Text></View>
              <Button title="SWAP" onPress={() => this.handleShow('SELL')} />
            </View>
          </View>
        </View>
      </View>
    );
  }

}

export default PanelMenu;
